import * as formulajs from "@formulajs/formulajs";
var SUPPORTED_FORMULAS = Object.keys(formulajs);
export default SUPPORTED_FORMULAS;